// removed by extract-text-webpack-plugin
module.exports = {"image":"src-components-modules-Media-MediaImageSlider-SliderImage-style----image-module---image---17j1y position-relative margin-xs display-inlineBlock borderRadius-m overflow-hidden","inner":"src-components-modules-Media-MediaImageSlider-SliderImage-style----image-module---inner---2KOzo position-absolute pinAll"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Media/MediaImageSlider/SliderImage/style/image.module.css
// module id = 738
// module chunks = 227233210825294 244429959259914